import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { FeedbackDTO } from './models/feedbackDTO';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-send-feedback-dialog',
    templateUrl: './send-feedback-dialog.component.html',
    styleUrls: ['./send-feedback-dialog.component.css'],
    standalone: true, 
    imports: [CommonModule, ReactiveFormsModule, MatDialogModule]
})
export class SendFeedbackDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<SendFeedbackDialogComponent>>(MatDialogRef);

  feedbackForm: UntypedFormGroup;

  ngOnInit(): void {
    this.feedbackForm = new UntypedFormGroup({
      'type': new UntypedFormControl(null, CustomValidators.required),
      'feedback': new UntypedFormControl(null, CustomValidators.required),
      'firstName': new UntypedFormControl(null, [CustomValidators.required]),
      'lastName' :new UntypedFormControl(null, [CustomValidators.required]),
      'email': new UntypedFormControl(null, [CustomValidators.required, CustomValidators.email]),
    }
      );

  }

  onSubmit(): void {


    let feedback = new FeedbackDTO();

    Object.assign(feedback, this.feedbackForm.value);

    this.dialogRef.close(feedback);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }


}
